import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { FaqItem } from "./components/faq-item/FaqItem";
import { FAQGroup as FAQGroupType } from "./types";

type Props = {
  data: FAQGroupType;
  activeQuestion: string;
  onSetActive: (id: string) => void;
};

export const FAQGroup: FC<Props> = ({ data, activeQuestion, onSetActive }) => {
  const lastQuestionIndex = data.data.length - 1;

  return (
    <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
      <div>
        <h4 className="text-regular text-base-400">{data.name}</h4>
        {data.data.map((faqItem, index) => {
          const id = `${data.id}-${index}`;

          return (
            <FaqItem
              key={id}
              id={id}
              isActive={activeQuestion === id}
              question={faqItem}
              onSetActive={onSetActive}
              isDividerHidden={index === lastQuestionIndex}
            />
          );
        })}
      </div>
    </Fade>
  );
};
